import ProductDetailImageField from './ProductDetailImageField';

export default ProductDetailImageField;
